export const SENTRY_SERVICE_CONTEXT = 'service';
